var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisiblePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11982 11.5529C1.73923 11.15 1.43069 10.8042 1.20145 10.5394C1.43069 10.2746 1.73923 9.92877 2.11982 9.52586C3.03039 8.56187 4.34792 7.2768 5.97351 5.99353C9.24819 3.40842 13.6569 0.922196 18.4439 0.922196C23.2309 0.922196 27.6397 3.40842 30.9143 5.99353C32.5399 7.2768 33.8575 8.56187 34.768 9.52586C35.1486 9.92877 35.4572 10.2746 35.6864 10.5394C35.4572 10.8042 35.1486 11.15 34.768 11.5529C33.8575 12.5169 32.5399 13.802 30.9143 15.0852C27.6397 17.6703 23.2309 20.1566 18.4439 20.1566C13.6569 20.1566 9.24819 17.6703 5.97351 15.0852C4.34792 13.802 3.03039 12.5169 2.11982 11.5529Z",
    stroke: "#C8C8C8",
    strokeWidth: 1.84439
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4439,
    cy: 10.5395,
    r: 4.3475,
    stroke: "#C8C8C8",
    strokeWidth: 1.84439
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisiblePassword);
export default __webpack_public_path__ + "static/media/VisiblePassword.1fe21e6375b2966d17abbdc442c757f7.svg";
export { ForwardRef as ReactComponent };